// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import MenuController from "./menu_controller"
application.register("menu", MenuController)

import TableFilterController from "./table_filter_controller"
application.register("table-filter", TableFilterController)
